var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgElPayment = function SvgElPayment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.75 5.025c0-.966.784-1.75 1.75-1.75h7c.966 0 1.75.784 1.75 1.75v7a1.75 1.75 0 0 1-1.75 1.75h-7a1.75 1.75 0 0 1-1.75-1.75v-7Zm1.75-.583a.583.583 0 0 0-.583.583v7c0 .323.26.584.583.584h7a.583.583 0 0 0 .583-.584v-7a.583.583 0 0 0-.583-.583h-7Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 2.11c-1.015 0-1.75.743-1.75 1.556v2.527a.583.583 0 1 1-1.167 0V3.666C4.083 2.116 5.438.943 7 .943c1.562 0 2.917 1.172 2.917 2.723v2.527a.583.583 0 0 1-1.167 0V3.666c0-.813-.735-1.556-1.75-1.556Z",
    clipRule: "evenodd"
  })));
};
export default SvgElPayment;